<template>
  <div
    :class="{
      checkbox: true,
      selected: checked,
    }"
    @click="onClick"
  ></div>
</template>

<style scoped lang="scss">
@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";

.checkbox {
  position: relative;
  margin: 0.5em;
  padding-left: 2em;
  background-image: url("../../assets/sidepanel-selectlist-not-selected.svg");
  background-repeat: no-repeat;
  background-size: 2em;
  background-position: left center;
  height: 2.5em;
  line-height: 2.5em;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;

  &.selected {
    background-image: url("../../assets/sidepanel-selectlist-selected.svg");
  }
}
</style>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
export default defineComponent({
  name: "check-box",
  props: {
    // 外部からの指定
    selected: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const checked = ref(false);

    watch(
      () => props.selected,
      (newVal) => {
        if (checked.value !== newVal) {
          checked.value = newVal;
        }
      },
      { immediate: true }
    );

    const onClick = (): void => {
      checked.value = !checked.value;
      emit("change", checked.value);
    };

    return { checked, onClick };
  },
});
</script>
